export const getUserLevelLabel = (level, t) => {
    const map = {
      0: t('profile.userLevel.0', 'Basic'),
      10: t('profile.userLevel.10', 'Supporter'),
      20: t('profile.userLevel.20', 'Partner'),
      30: t('profile.userLevel.30', 'Ambassador')
    };
    return map[level] || `Level ${level}`;
  };
  